<template>
  <wt-toggle
    class="transcribe-subtitles-toggle"
    v-model="checked"
    @toggle="$_onClick"
  />
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import app from '#/app';

export default Vue.extend({
  name: 'TranscribeSubtitlesToggle',

  data() {
    return {
      guid: app.guid(),
      checked: null,
    };
  },

  created() {
    this.checked = this.enableVOSubtitles;
  },

  computed: {
    ...mapState({
      enableVOSubtitles: (state) => state.story.enableVOSubtitles,
      transcriptions: (state) => state.story.transcriptions,
    }),
    ...mapGetters('timemachine', ['visualsWithPotentialTranscript']),
  },

  methods: {
    ...mapMutations(['setEnableVOSubtitles']),
    ...mapActions(['BULK_FETCH_TRANSCRIPTION']),

    async $_onClick() {
      this.checked = !this.enableVOSubtitles;
      this.setEnableVOSubtitles(this.checked);
      app.storyController.story.invalidateFullPreview();

      if (this.visualsWithPotentialTranscript.length) {
        _.each(this.visualsWithPotentialTranscript, (asset) => {
          const assetUUID = asset.metadata.assetUUID;
          const hisTranscript = this.transcriptions[assetUUID];

          if (!_.isEmpty(hisTranscript.tokens)) {
            asset.agd.showTranscription = this.checked;
          }
        });

        app.timelineGateway.serializeTimeline({
          e: 'reflexive change of visual showTranscription',
          skipHistory: false,
        });
      }

      if (this.checked && this.visualsWithPotentialTranscript.length) {
        this.BULK_FETCH_TRANSCRIPTION();
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.transcribe-subtitles-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;

  > .wticon {
    font-size: 16px;
    margin-right: 10px;
  }
}
</style>
